import { tv } from 'tailwind-variants'

export const progress = tv({
  slots: {
    container: 'h-1 w-full overflow-hidden bg-grey-200',
    bar: 'h-full bg-black ease-in-out web:transition-all web:duration-500',
  },
  variants: {
    isStepper: {
      true: {
        bar: 'h-full bg-success ease-in-out web:transition-all web:duration-500',
      },
    },
    rounded: {
      true: {
        container: 'rounded-full',
      },
    },
  },
})
